import { Route } from '@angular/router';

import { AuthGuard } from '@celum/authentication';
import { DialogLauncherComponent, NoPermissionComponent } from '@celum/formats/features/format';

import { AdminGuard } from './admin.guard';
import { PermissionGuard } from './permission.guard';

export const appRoutes: Route[] = [
  {
    path: 'logout',
    loadComponent: () => import('@celum/authentication').then(mod => mod.LogoutComponent)
  },
  {
    path: 'no-permission',
    component: NoPermissionComponent
  },
  {
    path: 'home',
    loadComponent: () => import('./components/formats-tab/formats-tab.component').then(mod => mod.FormatsTabComponent),
    canActivate: [AuthGuard, PermissionGuard]
  },
  {
    path: 'format/:id',
    component: DialogLauncherComponent,
    canActivate: [AuthGuard, PermissionGuard]
  },
  {
    path: 'specifications',
    loadComponent: () => import('./components/specification-list-tab/specification-list-tab.component').then(mod => mod.SpecificationListTabComponent),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'process-view',
    loadComponent: () => import('@celum/formats/features/process-view').then(mod => mod.ProcessViewComponent),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];
